interface FooterProps {
  extinctLogo?: string;
}

export default function Footer({ extinctLogo }: FooterProps = {}) {
  return (
    <footer className="w-full py-12 px-8 mt-20">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-[#714ED0] text-[10px] leading-tight flex items-center justify-center flex-wrap gap-1">
          <a
            href="https://MoMics.Org"
            className="text-[#714ED0] hover:text-[#8b64e8] transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            Museum of Microphones
          </a>
          <span>© {new Date().getFullYear()} by</span>
          <a
            href="https://MoMics.Org"
            className="text-[#714ED0] hover:text-[#8b64e8] transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            MoMics.Org
          </a>
          <span>is licensed under</span>
          <a
            href="https://creativecommons.org/licenses/by-nc-sa/4.0/"
            className="text-[#714ED0] hover:text-[#8b64e8] transition-colors inline-flex items-center gap-1"
            target="_blank"
            rel="noopener noreferrer"
          >
            CC BY-NC-SA 4.0
            {/* CC Icon */}
            <svg className="inline-block w-3 h-3" viewBox="0 0 24 24" fill="currentColor" aria-label="Creative Commons">
              <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 1.5c5.799 0 10.5 4.701 10.5 10.5S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5zm-1.5 5.25c-2.9 0-4.875 2.125-4.875 5.25s1.975 5.25 4.875 5.25c1.65 0 3-0.65 3.875-1.85l-1.6-1.1c-0.55 0.7-1.25 1.1-2.15 1.1-1.55 0-2.6-1.3-2.6-3.4s1.05-3.4 2.6-3.4c0.85 0 1.55 0.4 2.1 1.1l1.6-1.15c-0.85-1.15-2.2-1.8-3.85-1.8zm7.5 0c-2.9 0-4.875 2.125-4.875 5.25s1.975 5.25 4.875 5.25c1.65 0 3-0.65 3.875-1.85l-1.6-1.1c-0.55 0.7-1.25 1.1-2.15 1.1-1.55 0-2.6-1.3-2.6-3.4s1.05-3.4 2.6-3.4c0.85 0 1.55 0.4 2.1 1.1l1.6-1.15c-0.85-1.15-2.2-1.8-3.85-1.8z"/>
            </svg>
            {/* BY Icon */}
            <svg className="inline-block w-3 h-3" viewBox="0 0 24 24" fill="currentColor" aria-label="Attribution">
              <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 1.5c5.799 0 10.5 4.701 10.5 10.5S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5zm0 3a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm-3 6v1.5h1.5V18h3v-6h1.5v-1.5h-6z"/>
            </svg>
            {/* NC Icon */}
            <svg className="inline-block w-3 h-3" viewBox="0 0 24 24" fill="currentColor" aria-label="Non-Commercial">
              <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 1.5c5.799 0 10.5 4.701 10.5 10.5S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5zM4.594 4.594l14.812 14.812M12 6a4.5 4.5 0 00-4.5 4.5c0 .825.225 1.575.6 2.25l-.975.975c-.525-.9-.825-1.95-.825-3.075A5.7 5.7 0 0112 4.95a5.7 5.7 0 015.7 5.55c0 1.125-.3 2.175-.825 3.075l-.975-.975c.375-.675.6-1.425.6-2.25A4.5 4.5 0 0012 6zm0 1.5c.45 0 .825.375.825.825V9.75h1.425v1.5h-1.425v.975l2.25 2.25-.975.975-1.275-1.275v.075h-1.65v-3h-1.425v-1.5h1.425V8.325c0-.45.375-.825.825-.825z"/>
            </svg>
            {/* SA Icon */}
            <svg className="inline-block w-3 h-3" viewBox="0 0 24 24" fill="currentColor" aria-label="Share Alike">
              <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 1.5c5.799 0 10.5 4.701 10.5 10.5S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5zm0 4.5a4.8 4.8 0 00-4.8 4.8h1.8a3 3 0 016 0c0 1.05-.525 1.95-1.35 2.475L12 14.25v2.25h1.5v-1.35l1.05-.75A4.8 4.8 0 0012 6zm-.75 10.5v1.5h1.5v-1.5h-1.5z"/>
            </svg>
          </a>
        </p>
        {extinctLogo && (
          <p className="text-[#714ED0] text-[10px] leading-tight flex items-center justify-center flex-wrap gap-2 mt-1">
            <span>momics is sponsored by</span>
            <a
              href="https://www.extinctaudio.co.uk/"
              className="inline-flex items-center gap-2 text-[#714ED0] hover:text-[#8b64e8] transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={extinctLogo}
                alt="Extinct Audio Logo"
                className="inline-block h-4"
              />
              <span>Extinct Audio</span>
            </a>
          </p>
        )}
      </div>
    </footer>
  );
}
